import CertificadosUsuario from './Certificados'
import Listado from './Listado'
import NuevaSolicitud from './NuevaSolicitud'
import Revocacion from './Revocacion'
import Aceptacion from './Aceptacion'
import Certificados from './oficial-registro/Certificados'
import OficialesRegistro from './oficial-registro/OficialesRegistro'
import Aprobacion from './oficial-registro/Aprobacion'
import Rechazo from './oficial-registro/Rechazo'
import Renovacion from './Renovacion'

const BASE_PATH = '/ac'

const routes = [
  {
    path: BASE_PATH,
    meta: {
      requiresAuth: true,
      requiredRoles: ['or', 'suscriptor', 'lyris']
    },
    component: CertificadosUsuario,
    props: true,
    children: [
      {
        path: 'certificados',
        component: Listado,
        name: 'certificadosListado',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'suscriptor']
        }
      },
      {
        path: 'nuevo',
        component: NuevaSolicitud,
        name: 'certificadosNuevaSolicitud',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'suscriptor']
        }
      },
      {
        path: 'revocacion/:idCert',
        component: Revocacion,
        name: 'certificadosRevocacion',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'or', 'suscriptor']
        }
      },
      {
        path: 'renovacion/:idCert',
        component: Renovacion,
        name: 'certificadosRenovacion',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'suscriptor']
        }
      },
      {
        path: 'oficial-registro/certificados',
        component: Certificados,
        name: 'certificadosOficialRegistroListado',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'or']
        }
      },
      {
        path: 'oficial-registro/organizacion/:idOrganization',
        component: OficialesRegistro,
        name: 'oficialesRegistro',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'or']
        }
      },
      {
        path: 'or/aprobacion/:idCert',
        component: Aprobacion,
        name: 'certificadoAprobacion',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'or']
        }
      },
      {
        path: 'or/rechazo/:idCert',
        component: Rechazo,
        name: 'certificadoRechazo',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'or']
        }
      },
      {
        path: 'aceptacion/:idCert',
        component: Aceptacion,
        name: 'certificadoAceptacion',
        props: true,
        meta: {
          requiresAuth: true,
          requiredRoles: ['lyris', 'suscriptor']
        }
      }
    ]
  }
]
export default routes
